import React, { useState, useEffect } from "react";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { CSSTransition } from "react-transition-group";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import classNames from "classnames";
import disableScroll from "disable-scroll";
import Icon from "../../Elements/Icon/Icon.tsx";

const DefaultContainer = ({ children, props }) => {
  const {
    closeModal,
    getModalWithContainerSize,
    getIsAboutToClose,
    getModalOverlayClass,
  } = useModal();
  const { getDirection } = useContent();

  const [animation, setAnimation] = useState();
  const modalClassNames = classNames([
    "modal-overlay",
    getDirection(),
    getModalOverlayClass(),
  ]);

  // checking if user clicked on overlay to close it, preventing accidentally closing when user highlights text
  const mouseDownWasOnOverlayRef = React.useRef(false);

  const handleMouseDown = () => {
    mouseDownWasOnOverlayRef.current = true;
  };

  const handleMouseUp = () => {
    if (mouseDownWasOnOverlayRef.current) {
      closeModal();
    }
    mouseDownWasOnOverlayRef.current = false;
  };

  useEffect(() => {
    setAnimation(true);
    document.body.classList.add("stop-scroll");
    disableScroll.options = {
      disableWheel: false,
      disableScroll: true,
      disableKeys: false,
      keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40],
    };
    // disableScroll.on();
    return () => {
      document.body.classList.remove("stop-scroll");
      disableScroll.off();
    };
  }, []);

  return (
    <CSSTransition
      in={!!animation && !getIsAboutToClose()}
      classNames="modal"
      timeout={500}
      unmountOnExit={true}
    >
      <div
        className={modalClassNames}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      >
        <div
          className={getModalWithContainerSize()}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          // onMouseUp={(e) => e.stopPropagation()}
        >
          <div className="modal-content">{children}</div>
          <button className="modal-close-button">
            <Icon large name="x" disabledgray onClick={closeModal} />
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};

export const DefaultContainerNoClose = ({ children }) => {
  const { getModalWithContainerSize, getIsAboutToClose, getModalOverlayClass } =
    useModal();
  const { getDirection } = useContent();

  const [animation, setAnimation] = useState();
  const modalClassNames = classNames([
    "modal-overlay no-close",
    getDirection(),
    getModalOverlayClass(),
  ]);

  useEffect(() => {
    setAnimation(true);
    document.body.classList.add("stop-scroll");
    disableScroll.options = {
      disableWheel: false,
      disableScroll: true,
      disableKeys: false,
      keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40],
    };
    // disableScroll.on();
    return () => {
      document.body.classList.remove("stop-scroll");
      disableScroll.off();
    };
  }, []);

  return (
    <CSSTransition
      in={!!animation && !getIsAboutToClose()}
      classNames="modal"
      timeout={500}
      unmountOnExit={true}
    >
      <div className={modalClassNames}>
        <div
          className={getModalWithContainerSize()}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">{children}</div>
        </div>
      </div>
    </CSSTransition>
  );
};

export const DefaultTransparentContainer = ({ children, props }) => {
  const { getModalWithContainerSize, getIsAboutToClose, getModalOverlayClass } =
    useModal();
  const { getDirection } = useContent();

  const [animation, setAnimation] = useState();
  const modalClassNames = classNames([
    "modal-overlay dark",
    getDirection(),
    getModalOverlayClass(),
  ]);

  useEffect(() => {
    setAnimation(true);
    document.body.classList.add("stop-scroll");
    disableScroll.options = {
      disableWheel: false,
      disableScroll: true,
      disableKeys: false,
      keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40],
    };
    // disableScroll.on();
    return () => {
      document.body.classList.remove("stop-scroll");
      disableScroll.off();
    };
  }, []);

  return (
    <CSSTransition
      in={!!animation && !getIsAboutToClose()}
      classNames="modal"
      timeout={500}
      unmountOnExit={true}
    >
      <div className={modalClassNames}>
        <div
          className="modal-transparent-container"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">{children}</div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default DefaultContainer;
